// @flow
import React, {Component} from 'react';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import noResultsIcon from '../NoResultsBanner/no-results.svg';
import routerActions from '../../actions/router';
import searchParamsActions from '../../actions/searchParams';

import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './NoResultsBanner.less';

type DispatchProps = {
    filter: typeof routerActions.filter,
    resetInputParams: typeof searchParamsActions.resetInputParams
};

type Props = {} & DispatchProps;

export class NoResultsBanner extends Component<Props> {
    resetParams = () => {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'no results clear filters'
        });
        this.props.resetInputParams();
        this.props.filter();
    };
    render() {
        return (
            <div className="NoResultsBanner media-flex media-flex--right media-flex--xs">
                <figure className="media-flex__figure">
                    <img src={noResultsIcon()} alt="no results" />
                </figure>
                <div className="media-flex__content">
                    <div className="media-flex__body">
                        <h2>
                            <FormattedMessage
                                id="noResultsBanner"
                                description="No results banner"
                                defaultMessage="No results"
                            >
                                {(message) => message}
                            </FormattedMessage>
                        </h2>
                        <div className="NoResultsBanner-description">
                            <FormattedMessage
                                id="noResultsBannerText"
                                description="No results banner text"
                                defaultMessage="Try removing filters or zoom out on the map to search a larger area."
                            >
                                {(message) => message}
                            </FormattedMessage>
                        </div>
                    </div>
                    <div className="media-flex__footer">
                        <ButtonPrimary
                            size="sm"
                            id={'noResultsBanner'}
                            label={
                                <FormattedMessage
                                    id="clearAllFilters"
                                    description="Clear all filter button label"
                                    defaultMessage="Clear all filters"
                                />
                            }
                            onClick={this.resetParams}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    resetInputParams: searchParamsActions.resetInputParams,
    filter: routerActions.filter
};

export default connect(null, mapDispatchToProps)(NoResultsBanner);
